import React, {Component} from 'react'

import TableRowActionsComponent from './TableRowActions.component'

class TableRowActionsContainer extends Component {
  render() {
    return (
      <TableRowActionsComponent
        selectedRows={this.props.selectedRows}
        dataRow={this.props.dataRow}
        dataItems={this.props.dataItem}
        env={this.props.env}
        analytics={this.props.analytics}
      />
    )
  }
}

export default TableRowActionsContainer
